<div header="confirm" class="align-items-center">
    <p class="block mb-2" style="font-size: 18px;">{{config.data.heading}}</p>

    <div class="col-12 p-0 mb-1">
        <p class="m-0 text-xsm text-black-alpha font-bold">{{config.data.textAreaHeading}}:</p>
    </div>
    <div class="col-12 mb-3 p-0">
        <textarea rows="3" maxlength="200" (input)="onValueChange($event)" [value]="endMessage" cols="30" pInputTextarea [autoResize]="true" ></textarea>
    </div>
   
    <div class="flex justify-content-end gap-2">
        <p-button label="cancel" [outlined]="true" [text]="true" (click)="closeDialog()" />
        <p-button styleClass="freshgreen-background" severity="success" label="approve" (click)="approve()" />
        <p-button severity="danger" label="deny" (click)="deny()" />
    </div>
</div>
